import { FaArrowRight } from 'react-icons/fa';

const Items = ({ projectItems, className = "" }) => {
    return (
        <>
            {projectItems.map((projectItem) => {
                const { id, img, category, title, description, site } = projectItem;
                return (
                    <a href={site} target="_blank" rel="noopener noreferrer" className={`card card-two group !p-4 flex flex-col block max-w-[550px] mx-auto lg:mx-0 ${className} hover:border-primary/50 transition-all duration-300 hover:shadow-xl hover:-translate-y-1`} key={id}>
                        <div className="rounded-[18px] overflow-hidden">
                            <img src={img} alt="" className="h-[240px] w-full object-cover align-middle transition-all duration-[0.6s] ease-custom group-hover:scale-[1.04]" />
                        </div>
                        <div className="flex justify-between items-center mt-[30px] px-2">
                            <div>
                                <span className="text-primary text-tiny font-bold mb-[5px] block text-cs">{category}</span>
                                <h3 className="text-h4">{title}</h3>
                            </div>
                            <span className="link w-10 h-10 rounded-full border border-border flex items-center justify-center hover:border-primary hover:text-primary transition-all">
                                <FaArrowRight className='link__icon !ml-0 -rotate-45 text-lg'></FaArrowRight>
                            </span>
                        </div>
                        <p className=" mt-[15px] px-2">{description}</p>


                    </a>
                )
            })}
        </>
    )
}

export default Items